import { getPhoneNumber } from './common.js'
export default {
  init() {

    window.addEventListener('load', (event) => {
      var phoneNumber = getPhoneNumber();
      if(phoneNumber){
        $(`.contact-us-phone-mask`).prop('href', "tel:"+phoneNumber);
        $(`.contact-us-phone-mask-div`).attr("onclick", "location.href='tel:"+phoneNumber+"'");
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact-us.js